import React from 'react'
import PageTitle from './PageTitle'

const Interests = (props) => {

    return (
        <section>
            <div className='about-wrapper common-padding'>
                <PageTitle title="Interests" />
                <div className="mt-4 w-100">
                    <div className="p-3 rounded-lg mb-3 about-card">
                        <p className='m-0'>
                            Apart from being a developer, I enjoy most of my time being
                            outdoors & enjoy Cycling & Playing Football.<br />
                            When indoors, I follow a number of movies and television shows, also I
                            am a TechGeek and I spend a large amount of my free time
                            exploring the latest technologies.
                        </p>
                    </div>
                </div>
            </div>
            <div className="navi-wrapper">
                <button className="navi-btn" onClick={() => props.setActive("projects")} >
                    <i className='fa fa-arrow-up'></i>
                </button>
                <button className="navi-btn" onClick={() => props.setActive("home")} >
                    <i className='fa fa-home'></i>
                </button>
            </div>
        </section>
    )
}

export default Interests